module.exports = __webpack_public_path__ + "static/media/Email.7ce729de.svg";